import { useEffect, useState } from "react";
import { pub, API } from "@/lib/api";
import { Shell } from "./Shell";
import { useParams } from "react-router-dom";

export default function SignalPage() {
  const { token } = useParams();
  const [state, setState] = useState(null);
  useEffect(() => {
    pub.get(`/signal/${token}`).then((r) => setState(r.data)).catch(() => setState({ lost: true }));
  }, [token]);

  return (
    <Shell testid="hint-page" className="bg-black">
      <div className="flex-1 flex items-center justify-center">
        {!state && <span className="w1-cursor" />}
        {state?.lost && <div data-testid="hint-signal-lost" className="text-[11px] tracking-[0.4em] text-[color:var(--w1-muted)]">SIGNAL LOST</div>}
        {state && !state.lost && (state.has_video ? (
          <video data-testid="hint-video-player" src={`${API}/public/signal/${token}/video`} controls playsInline className="w-full max-w-3xl max-h-[80dvh] bg-black" />
        ) : (
          <div data-testid="hint-video-placeholder" className="w-full max-w-3xl aspect-video border border-[color:var(--w1-border)] flex items-center justify-center text-[11px] tracking-[0.3em] text-[color:var(--w1-muted)]">
            [ HINT VIDEO PLACEHOLDER — <span data-testid="hint-stage-title" className="ml-2">{state.hint.toUpperCase()}</span> ]
          </div>
        ))}
      </div>
    </Shell>
  );
}
